document.addEventListener('DOMContentLoaded', () => {
    window._klOnsite = window._klOnsite || [];
    const klaviyoFormLinks = document.querySelectorAll(`a[href^="#klaviyo-form-"]`);
    klaviyoFormLinks.forEach((link) => {
        const formId = link.getAttribute('href').replace('#klaviyo-form-', '');
        if (!formId) return;
        link.addEventListener('click', (e) => {
            e.preventDefault();
            window._klOnsite.push(['openForm', formId]);
        });
    });

    const mcOldLinks = document.querySelectorAll('a[href*="http://eepurl.com/St_i9"],a[href*="list-manage.com"]');
    mcOldLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            window._klOnsite.push(['openform', 'X7Tbrb']);
        })
    });
});
